jQuery(document).ready(function ($) {
	// Проверяем, есть ли нужные элементы на странице
	if ($('#related-posts-container').length === 0) {
		return; // Выходим, если секции нет на странице
	}

	// Получаем данные из data-атрибутов
	var currentPage = 1;
	var maxPages = $('#related-pagination').data('max-pages');
	var postId = $('#related-pagination').data('post-id');
	var categoryIds = $('#related-pagination').data('category-ids');
	var lang = $('#related-pagination').data('lang');
	var ajaxUrl = $('#related-pagination').data('ajax-url');
	var nonce = $('#related-pagination').data('nonce');

	// Тексты для уведомлений
	var loadingText =
		lang === 'en'
			? 'Loading...'
			: lang === 'kk'
				? 'Жүктелуде...'
				: 'Загрузка...';
	var errorText =
		lang === 'en'
			? 'Error loading posts'
			: lang === 'kk'
				? 'Жүктеу қатесі'
				: 'Ошибка загрузки';

	// Функция для отрисовки номеров страниц в список
	function renderPageNumbers(currentPage, maxPages) {
		var listHtml = '';

		// Определяем диапазон отображаемых страниц (максимум 3)
		var startPage = Math.max(1, currentPage - 1);
		var endPage = Math.min(maxPages, startPage + 2);

		// Корректировка startPage если endPage - startPage < 2
		if (endPage - startPage < 2) {
			startPage = Math.max(1, endPage - 2);
		}

		// Генерируем элементы списка с номерами страниц
		for (var i = startPage; i <= endPage; i++) {
			listHtml +=
				'<li class="pagination-nav__item">' +
				'<button class="pagination-nav__page-number ' +
				(i === currentPage ? 'pagination-nav__page-number--active' : '') +
				'" data-page="' +
				i +
				'">' +
				i +
				'</button>' +
				'</li>';
		}

		$('#pagination-list-container').html(listHtml);
	}

	// Функция загрузки постов
	function loadPosts(page) {
		$.ajax({
			url: ajaxUrl,
			type: 'POST',
			data: {
				action: 'load_related_posts',
				page: page,
				post_id: postId,
				category_ids: categoryIds,
				lang: lang,
				nonce: nonce,
			},
			beforeSend: function () {
				$('#related-posts-container')
					.addClass('loading')
					.append('<div class="loading-spinner">' + loadingText + '</div>');
			},
			success: function (response) {
				$('#related-posts-container')
					.removeClass('loading')
					.find('.loading-spinner')
					.remove();

				if (response.success) {
					$('#related-posts-container').html(response.data.html);
					currentPage = page;

					// Обновляем номера страниц
					renderPageNumbers(currentPage, maxPages);

					// Обновляем состояние кнопок навигации
					$('#pagination-prev').prop('disabled', currentPage === 1);
					$('#pagination-next').prop('disabled', currentPage === maxPages);
				} else {
					$('#related-posts-container').append(
						'<div class="error-message">' + errorText + '</div>',
					);
				}
			},
			error: function () {
				$('#related-posts-container')
					.removeClass('loading')
					.find('.loading-spinner')
					.remove();
				$('#related-posts-container').append(
					'<div class="error-message">' + errorText + '</div>',
				);
			},
		});
	}

	// Инициализация
	renderPageNumbers(currentPage, maxPages);

	// Обработчики кликов
	$(document).on(
		'click',
		'.pagination-nav__page-number:not(.pagination-nav__page-number--active)',
		function () {
			var page = $(this).data('page');
			loadPosts(page);
		},
	);

	$('#pagination-prev').click(function () {
		if (currentPage > 1) {
			loadPosts(currentPage - 1);
		}
	});

	$('#pagination-next').click(function () {
		if (currentPage < maxPages) {
			loadPosts(currentPage + 1);
		}
	});
});
